<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" />

                                <div class="box">
                                    <v-navigation />

                                    <form action="" method="POST" class="filter filter--search" novalidation @submit="onChangeLocationsTableFilter">
                                        <div class="form-group form-group--search">
                                            <input type="text" class="form-control form-control--small form-control--search" :placeholder="$t('search.term')" v-model="locationsTableFilter.search" />
                                            <button role="button" type="submit" class="button" :title="$t('search')">
                                                {{ $t('search') }}
                                            </button>
                                        </div>
                                    </form>

                                    <v-blocks id="blocks" :isLoading="locationsTableLoading" :items="locationsTableItems" :useDeactivatedSwitch="true" :showDeactivatedOnly="locationsTableFilter.show_deactivated_only" @onChangeShowDeactivatedOnly="onChangeShowDeactivatedOnlyLocationsTableFilter">
                                        <template slot="block" slot-scope="{ row }">
                                            <router-link :to="{ name : 'customers-view-customer-location', params : { customer : $route.params.customer, location : row.id } }" :title="row.company_name" class="block block--block">
                                                <div class="block--block__content">
                                                    <h2>{{ row.company_name }}</h2>
                                                    <p v-if="row.is_hq === true">{{ $t('customers.hq_location') }}</p>
                                                    <p>{{ $t('customers.location_number') }}: {{ row.location_number }}</p>
                                                    <p>{{ row.phone }}</p>
                                                    <p>{{ row.email }}</p>
                                                    <p>
                                                        {{ row.address1 }}<br>
                                                        {{ row.address2 }}<br>
                                                        {{ row.zipcode }} {{ row.city }}<br>
                                                        {{ $helpers.countries[row.country_code] }}
                                                    </p>
                                                </div>
                                                <template v-if="$store.getters.userIsAdmin">
                                                    <div v-if="row.risk" class="block--block__content location--risk">
                                                        <p>
                                                        <strong>{{$t('location.risk.risk_number')}}: {{row.risk.risk_number}}</strong><br>
                                                        <template v-if="row.risk.decided_budget">
                                                            {{ $t('location.risk.limit') }}: {{$helpers.formateCurrency(row.risk.decided_budget)}}
                                                        </template>
                                                        <template v-else>
                                                          <span class="u-color--alert">
                                                            <br>
                                                            <strong>{{ $t('location.risk.decided_budget.not_exist') }}</strong>
                                                          </span>
                                                        </template>
                                                        <template v-if="row.risk.valid_from"><br>
                                                            {{ $t('location.risk.valid_from') }}: {{row.risk.valid_from | moment('DD.MM.YYYY')}}
                                                        </template>
                                                        <template v-if="row.risk.valid_until"><br>
                                                            {{ $t('location.risk.valid_until') }}: {{row.risk.valid_until | moment('DD.MM.YYYY')}}
                                                        </template>
                                                        <span v-if="!row.risk.is_valid" class="u-color--alert">
                                                            <br>
                                                            <strong>{{$t('location.risk.not_valid')}}</strong>
                                                        </span>
                                                        </p>
                                                    </div>
                                                    <div v-else class="u-color--alert block--block__content">
                                                        <p><strong>{{$t('location.risk.no_risk_number')}}</strong></p>
                                                    </div>
                                                </template>
                                                <div class="block--block__action">
                                                    <template v-if="$store.getters.userHasPermission('location_update')">
                                                        <router-link :to="{ name : 'customers-update-customer-location', params : { customer : $route.params.customer , location : row.id} }" class="button gray-dark button--edit" :title="$t('update')">
                                                            {{ $t('update') }}
                                                        </router-link>
                                                    </template>
                                                </div>
                                            </router-link>
                                        </template>
                                    </v-blocks>
                                    <v-pagination :currentPage="locationsTableCurrentPage" :itemsPerPage="locationsTableItemsPerPage" :items="locationsTableItemsCount" @pageClicked="onChangeLocationsTablePage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PageHeader from '../../partials/PageHeader';
import PageLoading from '../../partials/PageLoading';
import ActionButtons from './../../partials/Foundation/ActionButtons';
import Navigation from './../Navigation';

import Blocks from './../../partials/Foundation/Blocks';
import Pagination from './../../partials/Foundation/Pagination';

export default {
        data() {
            return {
                loading                     : false,
                loadingError                : null,
                customerObject              : {
                    id                          : 0
                },
                locationsTableLoading       : true,
                locationsTableCurrentPage   : this.$route.query.page || 1,
                locationsTableItemsPerPage  : 8,
                locationsTableItems         : [],
                locationsTableItemsCount    : 0,
                locationsTableFilter        : {
                    search : this.$route.query.search || '',
                    show_deactivated_only : this.$route.query.show_deactivated_only || 0
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vBlocks                 : Blocks,
            vPagination             : Pagination
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('locations.title');
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.$store.getters.userHasPermission('location_create')) {
                    buttons.push({
                        action  : 'create-new',
                        router  : { name : 'customers-create-customer-location', params : { custumor : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('project_create')) {
                    buttons.push({
                        action  : 'create-new',
                        title   : this.$t('project.create_quick.title'),
                        router  : { name : 'customers-create-customer-project', params : { custumor : this.$route.params.customer } }
                    });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        methods : {
            onUpdateCustomer : function() {
                this.loadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdateLocationsTableItems();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdateLocationsTableItems(true);
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onUpdateFilterParameters: function () {
                let query = {
                    'page' : this.locationsTableCurrentPage
                };

                for (let key in this.locationsTableFilter) {
                    if (this.locationsTableFilter[key]) {
                        query[key] = this.locationsTableFilter[key];
                    }
                }

                this.$router.push({query : query});
            },
            onChangeLocationsTablePage : function (page) {
                this.locationsTableCurrentPage = page;

                this.onUpdateLocationsTableItems();
            },
            onChangeLocationsTableFilter : function (event) {
                event.preventDefault();

                this.locationsTableCurrentPage = 1;

                this.onUpdateLocationsTableItems();
            },
            onChangeShowDeactivatedOnlyLocationsTableFilter : function (show) {
                this.locationsTableFilter.show_deactivated_only = show;

                this.onUpdateLocationsTableItems();
            },
            onUpdateLocationsTableItems : function (firstUpdate) {
                if (!firstUpdate) {
                    this.onUpdateFilterParameters();
                }

                let promise = this.$api.clearParams()
                    .addParam('show_deactivated_only', this.locationsTableFilter.show_deactivated_only)
                    .addParam('customer', this.$route.params.customer)
                    .addParam('search', this.locationsTableFilter.search)
                    .setPageParams(this.locationsTableCurrentPage, this.locationsTableItemsPerPage)
                    .get('locations');

                promise.then((response => {
                    this.locationsTableItems        = response.data.data;
                    this.locationsTableItemsCount   = response.data.meta.pagination.total;

                    this.locationsTableLoading      = false;
                }).bind(this)).catch((error => {
                    this.locationsTableItems        = [];
                    this.locationsTableItemsCount   = 0;

                    this.locationsTableLoading      = false;
                }).bind(this));

                this.locationsTableLoading = true;
            }
        }
    }
</script>